import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { Paper, Typography, FormControl, InputLabel, Input, Button } from '@material-ui/core'
import { useStyles } from './two-fa-user-login.styles'
import { ITwoFaLoginUserInput } from 'app/shared/data-access/users/two-fa-login-user/ITwoFaLoginUserInput'
import {Link, NavLink} from 'react-router-dom'

type Props = {
  onTwoFaLogin: (input: ITwoFaLoginUserInput) => Promise<void>
}

const TwoFaUserLoginEmailView = (props: Props) => {
  const classes = useStyles()

  return (
    <main className={classes.main}>
      <Paper className={classes.paper}>
        <Link to={{ pathname: `//axs-ict.com` }} target="_blank" >
            <img src="/axs_logo_payoff.png" className={classes.branding} alt="AXS logo" />
        </Link>
        <Typography component="h1" variant="h5">
          Tweestapsverificatie
        </Typography>
        <Formik
          initialValues={{ twoFaCode: '' } as ITwoFaLoginUserInput}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(false)
            await props.onTwoFaLogin(values)
          }}
        >
          {({ errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, initialValues, isValid }) => (
            <form className={classes.form} onSubmit={handleSubmit}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="twoFaCode">Code</InputLabel>
                <Input
                  defaultValue={initialValues.twoFaCode}
                  id="twoFaCode"
                  name="twoFaCode"
                  autoComplete="twoFaCode"
                  autoFocus
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.twoFaCode && touched.twoFaCode && errors.twoFaCode}
              </FormControl>

              <Button
                disabled={isSubmitting || !isValid}
                onClick={(e: React.MouseEvent | React.KeyboardEvent) => {
                  e.preventDefault()
                  handleSubmit()
                }}
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Bevestig login code
              </Button>
              <NavLink to="/login">Terug naar inloggen</NavLink>
            </form>
          )}
        </Formik>
      </Paper>
    </main>
  )
}

TwoFaUserLoginEmailView.propTypes = {
  onTwoFaLogin: PropTypes.func,
}

export default TwoFaUserLoginEmailView
